import Dexie from "dexie";

export const db = new Dexie("HEPDatabase");
db.version(1).stores({
  meditationPlaces: "id, userId, name, city_id, postal_code",
  satsangEvent: "++id, eventId, userId, order",
  defaultMeditationPlace: "++id, userId",
  appUser: "++id, userId",
});
db.version(2).stores({
  eventCalendarData: "++id, monthKey, userId",
});
